module.exports = __webpack_public_path__ + "img/nodeType1.bd2e6963.svg";